import {Injectable} from '@angular/core';
import {TranslocoService} from "@jsverse/transloco";
import {PrimeNGConfig} from "primeng/api";
import {from, take} from "rxjs";
import {switchMap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ChangeLangService {

  constructor(private translateService: TranslocoService, private primengConfig: PrimeNGConfig) {
  }

  public changeLang(lang: string) {
    this.translateService.setDefaultLang(lang);
    from(this.translateService.load(this.translateService.getActiveLang())).pipe(
      switchMap(() => this.translateService.selectTranslation().pipe(take(1)))
    ).subscribe(translations => {
      this.primengConfig.setTranslation({
        ...(translations as any),
        //calendar
        dayNames: translations['primeng.dayNames'],
        dayNamesShort: translations['primeng.dayNamesShort'],
        dayNamesMin: translations['primeng.dayNamesMin'],
        monthNames: translations['primeng.monthNames'],
        monthNamesShort: translations['primeng.monthNamesShort'],
        today: translations['primeng.today'],
        clear: translations['primeng.clear'],
        dateFormat: translations['primeng.dateFormat'],
        firstDayOfWeek: translations['primeng.firstDayOfWeek'] ,
        // file upload non li prende
        invalidFileSizeMessageSummary: translations['primeng.invalidFileSizeMessageSummary'] ,
        invalidFileSizeMessageDetail: translations['primeng.invalidFileSizeMessageDetail'],
        invalidFileTypeMessageSummary: translations['primeng.invalidFileTypeMessageSummary'],
        invalidFileTypeMessageDetail: translations['primeng.invalidFileTypeMessageDetail'],
        invalidFileLimitMessageSummary: translations['primeng.invalidFileLimitMessageSummary'],
        invalidFileLimitMessageDetail: translations['primeng.invalidFileLimitMessageDetail']

      });
    });
  }
}
